import { memo } from 'react';



interface FilterSelectButtonsProps {
	onConfirm: () => void,
	onCancel: () => void,
	disabled: boolean,
}


const FilterSelectButtons = (props: FilterSelectButtonsProps) => {
	const { onConfirm, onCancel, disabled } = props;
	
	return (
		<div className='popover-filter-buttons'>
			
			<button className='filter-popover-button confirm-button' onClick={onConfirm} disabled={disabled}>
				Potvrdit
			</button>
			
			<button className='filter-popover-button' onClick={onCancel}>
				Zrušit
			</button>
		
		</div>
	);
};

export default memo(FilterSelectButtons);